import React from 'react';
import Container from '../layout/Container';
import SectionTitle from '../ui/SectionTitle';
import PricingCard from '../ui/PricingCard';

const PricingSection: React.FC = () => {
  const pricingTiers = [
    {
      name: 'Core',
      description: 'Essential features for agents getting started with IDX.',
      features: [
        'Standard IDX search integration',
        'Essential plug-and-play widgets',
        'Basic customizable map search',
        'My Listings Manager',
        'Limited lead capture tools',
        'Basic contact form',
        'Mobile-friendly design',
        'Light SEO tuning',
        'IDX subdomain',
        'Premium support'
      ],
    },
    {
      name: 'Engage',
      description: 'Advanced features to grow engagement and visibility.',
      features: [
        'All Core features',
        'Market Reports',
        'Sold Data (if available from MLS)',
        'AI Smart Search',
        'AI Listing Descriptions',
        'Lead capture forms with triggers',
        'CRM sync options',
        'Enhanced SEO',
        'Optional custom domain',
        'Embeddable IDX widgets'
      ],
      popular: true,
    },
    {
      name: 'Elite',
      description: 'Complete solution for standout real estate professionals.',
      features: [
        'All Engage features',
        'Full custom-branded luxury website',
        'Custom homepage layout',
        'Full-screen property showcase',
        'Video background integration',
        'Advanced behavior-based automation',
        'Custom map search filters',
        'Social media integration',
        'Full blog & content manager',
        'Integrated hosting + CDN'
      ],
    }
  ];

  return (
    <section className="py-20">
      <Container>
        <SectionTitle
          title="Find the Perfect Plan for Your Business"
          subtitle="Every plan is quoted for the agent or team after a short call"
          centered
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pricingTiers.map((tier, index) => (
            <PricingCard
              key={index}
              name={tier.name}
              description={tier.description}
              features={tier.features}
              popular={tier.popular}
              delay={index}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default PricingSection;